<template>
    <Card title="Pro-Active Activity" >
        <p>Noisy Clients Resolved: 12</p>
        <p>XYZ Item Resolved: 21</p>
        <p>abc</p>
    </Card>

</template>

<script>
import Card from '../Card.vue'
export default {
  name: 'ProActiveCard',
  components: {
    Card
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Cards/InfoCards/ProActiveCard.vue